import validation from '../../../../../../modules/Gull/Framework/validation.js';

const stap3 = {

	init() {

		document.getElementById('modalWerknemersGegevensLink')?.addEventListener('click', async () => {
			const grid = await import('./stap3/werknemersGrid.js');
			grid.default.init();
		});

		// Bind datumPersoneelInDienstChange functie onblur aan datumPersoneelInDienst veld
		$('#datumPersoneelInDienst').blur(stap3.datumPersoneelInDienstChange);

		// Toon percentage veld bij provisie
		$('#provisie').change(stap3.toggleProvisieChange);
		$('#provisiePercentage').change(stap3.toggleProvisieChange);

		// Toon verberg provisiepercentage bij pageload
		stap3.toggleProvisieChange();

		// Draai datumPersoneelInDienstChange functie bij pageload
		stap3.datumPersoneelInDienstChange();

		// Binding van toggleUploadType functie aan select
		$('#loyalisAanlevering').change(function() {
			stap3.toggleUploadType();
		});

		// Toon of verberg bijbehorende velden bij pageload
		stap3.toggleUploadType();

		// Koppel functie aan mantel veld
		$('#wensenEnBehoeftenToets').change(function() {
			stap3.toggleIndicatieWensenEnBehoeften();
		});

		// Draai functie bij laden van pagina
		stap3.toggleIndicatieWensenEnBehoeften();

		// set werknemersCount label
		stap3.getWerknemersCountFromDOM();

	},

	// Functie om verzuimpercentage velden te tonen en te verbergen op basis van datum personeel in dienst
	datumPersoneelInDienstChange: function() {

		// Voer inhoud van functie alleen uit als het veld #datumPersoneelInDienst bestaat
		if ($('#datumPersoneelInDienst').length) {
			$('#PC_VERZUIM1').attr('data-validate', '').closest('.form-group').addClass('d-none');
			$('#PC_VERZUIM2').attr('data-validate', '').closest('.form-group').addClass('d-none');
			$('#PC_VERZUIM3').attr('data-validate', '').closest('.form-group').addClass('d-none');
			$('#verzuimRapportage1').attr('data-validate', '').closest('.form-group').addClass('d-none');
			$('#verzuimRapportage2').attr('data-validate', '').closest('.form-group').addClass('d-none');
			$('#verzuimRapportage3').attr('data-validate', '').closest('.form-group').addClass('d-none');
			var value = $('#datumPersoneelInDienst').val();
			var m = value.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
			if (m != null) {
				var ingangsdatum = new Date(m[3], m[2] - 1, m[1]);
				var PC_VERZUIM1 = new Date($('#PC_VERZUIM1').attr('data-showByYear'), 12, 0);
				if (ingangsdatum.getTime() <= PC_VERZUIM1.getTime()) {
					$('#PC_VERZUIM1').attr('data-validate', 'required decimalsAllowed range').closest('.form-group').removeClass('d-none');
					$('#verzuimRapportage1').closest('.form-group').removeClass('d-none');
				}

				var PC_VERZUIM2 = new Date($('#PC_VERZUIM2').attr('data-showByYear'), 12, 0);
				if (ingangsdatum.getTime() <= PC_VERZUIM2.getTime()) {
					$('#PC_VERZUIM2').attr('data-validate', 'required decimalsAllowed range').closest('.form-group').removeClass('d-none');
					$('#verzuimRapportage2').closest('.form-group').removeClass('d-none');
				}

				var PC_VERZUIM3 = new Date($('#PC_VERZUIM3').attr('data-showByYear'), 12, 0);
				if (ingangsdatum.getTime() <= PC_VERZUIM3.getTime()) {
					$('#PC_VERZUIM3').attr('data-validate', 'required decimalsAllowed range').closest('.form-group').removeClass('d-none');
					$('#verzuimRapportage3').closest('.form-group').removeClass('d-none');
				}
			}
		}
	},

	// Functie om provisiepercentage aan en uit te toggelen TODO: Validate netjes maken
	toggleProvisieChange: function() {
		if ($('#provisie').val() == 'exclusief') {
			$('#provisiePercentage').attr('data-validate', '').closest('.form-group').addClass('d-none').addClass('d-none');
			$('#provisiePercentage').append($('<option></option>').attr('value', '0').text('0%'));
			$('#provisiePercentage').val(0);
		} else if ($('#provisie').val() == 'inclusief') {
			if ($('#provisiePercentage').val() == 0) {
				$('#provisiePercentage').val($('#provisiePercentage').attr('data-value'));
			}
			$('#provisiePercentage option[value=0]').remove();
			$('#provisiePercentage').attr('data-validate', 'required decimalsAllowedNoChange').closest('.form-group').removeClass('d-none').removeClass('d-none');
			$('#provisiePercentage').attr('data-value', $('#provisiePercentage').val());
			$('#provisiePercentage').focus();
		}
	},

	// Functie die toont of verbergt bijbehorende velden bij soort upload
	toggleUploadType: function() {
		if ($('#loyalisAanlevering').val() == 'los') {
			$('#loyalisWerknemersUpload,#loyalisZiekenUpload,#loyalisWiaInstroomUpload').closest('.form-group').removeClass('d-none');
			$('#loyalisWerknemersUpload,#loyalisZiekenUpload,#loyalisWiaInstroomUpload').each(function() {
				if ($(this).data('file') == '') {
					validation.addRequired($(this));
				}
			});
			$('#loyalisAdfizUpload').closest('.form-group').addClass('d-none');
			validation.removeRequired($('#loyalisAdfizUpload'));
		} else {
			$('#loyalisWerknemersUpload,#loyalisZiekenUpload,#loyalisWiaInstroomUpload').closest('.form-group').addClass('d-none');
			validation.removeRequired($('#loyalisWerknemersUpload,#loyalisZiekenUpload,#loyalisWiaInstroomUpload'));
			$('#loyalisAdfizUpload').closest('.form-group').removeClass('d-none');
			if ($('#loyalisAdfizUpload').data('file') == '') {
				validation.addRequired($('#loyalisAdfizUpload'));
			}
		}
	},

	// Functie om Indicatie wensen en behoefte te tonen en verbergen
	toggleIndicatieWensenEnBehoeften: function() {
		var e = $('#wensenEnBehoeftenToets');
		var t = $('#wensenEnBehoeftenToetsIndicatie');
		if (e.length) {
			if (e.val() === 'j') {
				t.closest('.form-group').removeClass('d-none');
				validation.addRequired(t);
			} else {
				t.closest('.form-group').addClass('d-none');
				validation.removeRequired(t);
			}
		}
	},

	/**
	 * Verkrijg de eventueel eerder opgeslagen werknemersgegevens uit DOM veld werknemersUploadV2
	 *
	 * @return void
	 */
	getWerknemersCountFromDOM: function() {
		var werknemersUploadV2 = document.getElementById('werknemersUploadV2') || null;
		if (null !== werknemersUploadV2) {
			var werknemersDataCSV = document.getElementById('werknemersUploadV2').value;
			if (werknemersDataCSV !== '') {
				var werknemersLines = werknemersDataCSV.split('|');
				document.getElementById('werknemersUploadV2Count').innerHTML = werknemersLines.length;
			}
		}
	},

};

export default stap3;
